import {
  LuFileText, LuFileSpreadsheet, LuPresentation, LuImage, LuFileAudio, LuFileVideo, LuFileArchive, LuLink, LuFile,
} from 'react-icons/lu';
import api from '../services/api';

// Utilitários compartilhados das telas de Materiais de Apoio (gestão e colaborador).

const BY_EXT = {
  pdf: { icon: <LuFileText />, label: 'PDF', tone: 'danger' },
  doc: { icon: <LuFileText />, label: 'Word', tone: 'info' },
  docx: { icon: <LuFileText />, label: 'Word', tone: 'info' },
  odt: { icon: <LuFileText />, label: 'Documento', tone: 'info' },
  rtf: { icon: <LuFileText />, label: 'Documento', tone: 'info' },
  txt: { icon: <LuFileText />, label: 'Texto', tone: 'neutral' },
  xls: { icon: <LuFileSpreadsheet />, label: 'Excel', tone: 'success' },
  xlsx: { icon: <LuFileSpreadsheet />, label: 'Excel', tone: 'success' },
  ods: { icon: <LuFileSpreadsheet />, label: 'Planilha', tone: 'success' },
  csv: { icon: <LuFileSpreadsheet />, label: 'CSV', tone: 'success' },
  ppt: { icon: <LuPresentation />, label: 'PowerPoint', tone: 'warning' },
  pptx: { icon: <LuPresentation />, label: 'PowerPoint', tone: 'warning' },
  odp: { icon: <LuPresentation />, label: 'Apresentação', tone: 'warning' },
  png: { icon: <LuImage />, label: 'Imagem', tone: 'purple' },
  jpg: { icon: <LuImage />, label: 'Imagem', tone: 'purple' },
  jpeg: { icon: <LuImage />, label: 'Imagem', tone: 'purple' },
  gif: { icon: <LuImage />, label: 'Imagem', tone: 'purple' },
  webp: { icon: <LuImage />, label: 'Imagem', tone: 'purple' },
  mp3: { icon: <LuFileAudio />, label: 'Áudio', tone: 'purple' },
  wav: { icon: <LuFileAudio />, label: 'Áudio', tone: 'purple' },
  mp4: { icon: <LuFileVideo />, label: 'Vídeo', tone: 'purple' },
  zip: { icon: <LuFileArchive />, label: 'ZIP', tone: 'neutral' },
};

/** Ícone, rótulo e tom de cor do tipo do material. */
export const materialType = (m) => {
  if (m.kind === 'link') return { icon: <LuLink />, label: 'Link', tone: 'info' };
  return BY_EXT[m.extension] || { icon: <LuFile />, label: (m.extension || 'arquivo').toUpperCase(), tone: 'neutral' };
};

export const toneStyle = (tone) => {
  if (tone === 'neutral') return { background: 'var(--surface-3)', color: 'var(--text-2)' };
  return { background: `var(--${tone}-soft)`, color: `var(--${tone})` };
};

export const fmtSize = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
};

/**
 * Abre o link ou baixa o arquivo (com o token de acesso, via api.js).
 * `basePath`: '/support-materials' (gestão) ou '/my-materials' (colaborador).
 */
export async function openMaterial(basePath, m) {
  if (m.kind === 'link') {
    window.open(m.external_url, '_blank', 'noopener,noreferrer');
    return;
  }
  let res;
  try {
    res = await api.get(`${basePath}/${m.id}/download`, { responseType: 'blob' });
  } catch (e) {
    // Erro vem como blob JSON — extrai a mensagem do backend.
    let msg = 'Não foi possível baixar o arquivo.';
    try { msg = JSON.parse(await e.response.data.text()).error || msg; } catch { /* ignore */ }
    throw new Error(msg);
  }
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = m.file_name || 'material';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
